var _a;
import { createActions } from 'redux-actions';
export var getSorts = (_a = createActions('GET_SORTS', 'GET_SORTS_COMPLETE'), _a.getSorts), getSortsComplete = _a.getSortsComplete;
